// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"button_wrapper__2XRNu","button":"button_button__3E2I8","active":"button_active__3m96_"};